import { Buffer } from 'buffer';

import React, { Component } from 'react';

import axios from 'axios';
import SignatureCanvas from 'react-signature-canvas';

import validator from 'validator';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
  } from "react-router-dom";

import cn from 'classnames';
import bank from '../scss/bank.module.scss';

import DatePicker from 'react-date-picker';

import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';

global.Buffer = Buffer;

const iban = (value) => {
    if( !value.toString().trim().length < 22 ) {
        return 'Bitte prüfen Sie die IBAN!';
    }
}

const required = (value) => {
    if (!value.toString().trim().length) {
        return 'Pflichtfeld';
    }
};

const email = (value) => {
    if (!validator.isEmail(value)) {
        return `${value} ist keine gültige E-Mail.`
    }
};

class Fire extends Component {
    constructor(props) {
        super(props);
        this.state= {
            team: this.props.team,
            requiredError: false,
            captchaError: false,
            salutation: '',
            firstname: '',
            surname: '',
            birthName: '',
            nationality: '',
            marital: '',
            birthday: '',
            email: '',
            telephone: '',
            addressSecondary: '',
            address: '',
            addressNumber: '',
            zip: '',
            city: '',
            country: '',
            hours: '',
            birthCity: '',
            clothingSize: '',
            gender: '',
            status: '',
            insurance: '',
            taxID: '',
            rvID: '',
            liberation: '',
            others: '',
            insuranceName: '',
            short: '',
            shortDays: '',
            employer: '',
            birthName: '',
            beginn_1: '',
            beginn_2: '',
            adresse_1: '',
            adresse_2: '',
            option_1_1: false,
            option_1_2: false,
            option_1_3: false,
            option_1_4: false,
            option_2_1: false,
            option_2_2: false,
            option_2_3: false,
            option_2_4: false,
            signature: '',
            ownOwnership: true,
            familyOwnership: false,
            bankName: '',
            bankOwner: '',
            bankIban: '',
            bankBic: ''
        }
    }
    componentDidMount () {
        loadCaptchaEnginge(6); 
    };
    dateIsValid(date) {
        return date instanceof Date && !isNaN(date) && date.getMonth();
    }
    changeDate = e => {
        e.setDate(e.getDate() + 1);
        let date = JSON.stringify(e);
        date = date.slice(1,11);
        this.setState({
            birthday: date
        });
    };
    handleSubmit(event) {
        event.preventDefault();
        this.setState({ captchaError: false, requiredError: false });
        this.setState({ signature: this.sigCanvas.getTrimmedCanvas().toDataURL('image/png') });
        let user_captcha_value = document.getElementById('user_captcha_input').value;
        if( !validator.isEmpty( this.state.salutation ) && !validator.isEmpty( this.state.firstname ) && !validator.isEmpty( this.state.surname ) && !validator.isEmpty( this.state.birthName ) && !validator.isEmpty( this.state.birthCity ) && !validator.isEmpty( this.state.email ) && !validator.isEmpty( this.state.telephone ) && !validator.isEmpty( this.state.address ) && !validator.isEmpty( this.state.zip ) && !validator.isEmpty( this.state.city ) && !validator.isEmpty( this.state.country ) && !validator.isEmpty( this.state.gender ) && !validator.isEmpty( this.state.hours ) && !validator.isEmpty( this.state.status ) && !validator.isEmpty( this.state.insurance ) && !validator.isEmpty( this.state.taxID ) && !validator.isEmpty( this.state.rvID ) && !validator.isEmpty( this.state.liberation ) && !validator.isEmpty( this.state.employer ) && !validator.isEmpty( this.state.short ) && this.state.birthday != '' ) {
            if ( validateCaptcha( user_captcha_value) == true ) {
                const config = {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                };
                const params = new URLSearchParams();
                params.append('team', this.state.team);
                params.append('recipient', 2);
                params.append('salutation', this.state.salutation);
                params.append('firstname', this.state.firstname);
                params.append('surname', this.state.surname);
                params.append('birthName', this.state.birthName);
                params.append('nationality', this.state.nationality);
                params.append('marital', this.state.marital);
                params.append('birthday', this.state.birthday);
                params.append('email', this.state.email);
                params.append('telephone', this.state.telephone);
                params.append('addressSecondary', this.state.addressSecondary);
                params.append('address', this.state.address);
                params.append('addressNumber', this.state.addressNumber);
                params.append('zip', this.state.zip);
                params.append('city', this.state.city);
                params.append('country', this.state.country);
                params.append('hours', this.state.hours);
                params.append('birthCity', this.state.birthCity);
                params.append('clothingSize', this.state.clothingSize);
                params.append('gender', this.state.gender);
                params.append('taxID', this.state.taxID);
                params.append('rvID', this.state.rvID);
                params.append('liberation', this.state.liberation);
                params.append('others', this.state.others);
                params.append('insurance', this.state.insurance);
                params.append('insuranceName', this.state.insuranceName);
                params.append('short', this.state.short);
                params.append('shortDays', this.state.shortDays);
                params.append('employer', this.state.employer);
                params.append('birthName', this.state.birthName);
                params.append('status', this.state.status);

                params.append('beginn_1', this.state.beginn_1);
                params.append('beginn_2', this.state.beginn_2);
                params.append('adresse_1', this.state.adresse_1);
                params.append('adresse_2', this.state.adresse_2);
                params.append('option_1_1', this.state.option_1_1);
                params.append('option_1_2', this.state.option_1_2);
                params.append('option_1_3', this.state.option_1_3);
                params.append('option_1_4', this.state.option_1_4);
                params.append('option_2_1', this.state.option_2_1);
                params.append('option_2_2', this.state.option_2_2);
                params.append('option_2_3', this.state.option_2_3);
                params.append('option_2_4', this.state.option_2_4);

                params.append('ownOwnership', this.state.ownOwnership);
                params.append('familyOwnership', this.state.familyOwnership);

                params.append('bankName', this.state.bankName);
                params.append('bankOwner', this.state.bankOwner);
                params.append('bankIban', this.state.bankIban);
                params.append('bankBic', this.state.bankBic);

                axios.post( 'https://anmeldung.musiceggert.de/send.php', params, config)
                    .then(response => window.location.replace('/vielen-dank') )
                    .catch(error => {
                        console.error('There was an error!', error);
                    });
            } else {
                this.setState({ requiredError: true });
            }
        } else {
            this.setState({ captchaError: true });
        }
        loadCaptchaEnginge(6); 
    }
    render() {
        return (
            <section className="line">
                <div className="container">
                    <h1>Personalanmeldung</h1>
                    <form onSubmit={(event) => this.handleSubmit(event)}>
                        <div className="row">
                            <div className="col">
                                <h3>Persönliche Angaben</h3>
                                    <div className="form-row">
                                        <label htmlFor="salutation">Anrede <span className="required" title="Pflichtfeld">*</span>
                                            <select id="salutation" name='salutation' value={this.state.salutation} validations={[required]} onChange={e => this.setState({ salutation: e.target.value })}>
                                                <option value="">Bitte auswählen</option>
                                                <option value="0">Frau</option>
                                                <option value="1">Herr</option>
                                            </select>
                                        </label>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <label htmlFor="firstname">Vorname <span className="required" title="Pflichtfeld">*</span>
                                                <input type="text" id="firstname" name="firstname" validations={[required]} onChange={e => this.setState({ firstname: e.target.value })}/>
                                            </label>
                                        </div>
                                        <div className="col">
                                            <label htmlFor="surname">Nachname <span className="required" title="Pflichtfeld">*</span>
                                                <input type="text" id="surname" name="surname" validations={[required]} onChange={e => this.setState({ surname: e.target.value })}/>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <label htmlFor="birthName">Geburtsname <span className="required" title="Pflichtfeld">*</span>
                                            <input type="text" id="birthName" name="birthName" validations={[required]} onChange={e => this.setState({ birthName: e.target.value })}/>
                                        </label>
                                    </div>
                                    <div className="form-row">
                                        <label htmlFor="nationality">Staatsangehörigkeit <span className="required" title="Pflichtfeld">*</span>
                                            <input type="text" id="nationality" name="nationality" validations={[required]} value={this.state.nationality} onChange={e => this.setState({ nationality: e.target.value })}/>
                                        </label>
                                    </div>
                                    <div className="form-row">
                                        <label htmlFor="marital">Familienstand <span className="required" title="Pflichtfeld">*</span>
                                            <select id="marital" name='marital' value={this.state.marital} validations={[required]} onChange={e => this.setState({ marital: e.target.value })}>
                                                <option value="">Bitte auswählen</option>
                                                <option value='0'>ledig</option>
                                                <option value='1'>verheiratet</option>
                                                <option value='2'>verwitwet</option>
                                                <option value='3'>geschieden</option>
                                            </select>
                                        </label>
                                    </div>
                                    <div className="form-row">
                                        <label htmlFor="birthday">Geburtsdatum <span className="required" title="Pflichtfeld">*</span>
                                            <DatePicker dateFormat="d.m.Y" onChange={(e) => this.changeDate(e)} />
                                        </label>
                                    </div>
                                    <div className="form-row">
                                        <label htmlFor="birthCity">Geburtsort <span className="required" title="Pflichtfeld">*</span>
                                            <input type="text" id="birthCity" name="birthCity" validations={[required]} onChange={e => this.setState({ birthCity: e.target.value })}/>
                                        </label>
                                    </div>
                            </div>
                            <div className="col">
                                <h3>Kontaktdaten</h3>
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor="email">E-Mail <span className="required" title="Pflichtfeld">*</span>
                                            <input type="email" id="email" name="email" validations={[required, email]} onChange={e => this.setState({ email: e.target.value })}/>
                                        </label>
                                    </div>
                                    <div className="col">
                                        <label htmlFor="telephone">Telefonnummer <span className="required" title="Pflichtfeld">*</span>
                                            <input type="tel" id="telephone" name="telephone" validations={[required]} onChange={e => this.setState({ telephone: e.target.value })}/>
                                        </label>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <label htmlFor="addressSecondary">Adresszusatz
                                        <input type="text" id="addressSecondary" name="addressSecondary" onChange={e => this.setState({ addressSecondary: e.target.value })}/>
                                    </label>
                                </div>
                                <div className="form-row">
                                    <label htmlFor="address">Straße, Hausnummer <span className="required" title="Pflichtfeld">*</span>
                                        <div className="row">
                                            <div className="col" style={{flex: 3}}>
                                                <input type="text" id="address" name="address" placeholder="Straße..." validations={[required]} onChange={e => this.setState({ address: e.target.value })}/>
                                            </div>
                                            <div className="col">
                                                <input type="text" id="addressNumber" name="addressNumber" placeholder="Hausnummer..." validations={[required]} onChange={e => this.setState({ addressNumber: e.target.value })}/>
                                            </div>
                                        </div>
                                    </label>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor="zip">Postleitzahl <span className="required" title="Pflichtfeld">*</span>
                                            <input type="text" id="zip" name="zip" validations={[required]} onChange={e => this.setState({ zip: e.target.value })}/>
                                        </label>
                                    </div>
                                    <div className="col">
                                        <label htmlFor="city">Wohnort <span className="required" title="Pflichtfeld">*</span>
                                            <input type="text" id="city" name="city" validations={[required]} onChange={e => this.setState({ city: e.target.value })}/>
                                        </label>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <label htmlFor="country">Land <span className="required" title="Pflichtfeld">*</span>
                                        <input type="text" id="country" name="country" validations={[required]} onChange={e => this.setState({ country: e.target.value })}/>
                                    </label>
                                </div>
                                <div className="form-row">
                                    <label htmlFor="gender">Geschlecht <span className="required" title="Pflichtfeld">*</span>
                                        <select id="gender" name='gender' value={this.state.gender} validations={[required]} onChange={e => this.setState({ gender: e.target.value })}>
                                            <option value="">Bitte auswählen</option>
                                            <option value='1'>männlich</option>
                                            <option value='2'>weiblich</option>
                                            <option value='3'>divers</option>
                                        </select>
                                    </label>
                                </div>
                                <div className="form-row">
                                    <label htmlFor="clothingSize">Konfektionsgröße <span className="required" title="Pflichtfeld">*</span>
                                        <select id="clothingSize" name='clothingSize' value={this.state.clothingSize} validations={[required]} onChange={e => this.setState({ clothingSize: e.target.value })}>
                                            <option value="">Bitte auswählen</option>
                                            <option value='1'>S</option>
                                            <option value='2'>M</option>
                                            <option value='3'>L</option>
                                            <option value='4'>XL</option>
                                            <option value='5'>XXL</option>
                                            <option value='6'>XXXL</option>
                                        </select>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <h3>Arbeitszeiten</h3>
                        <div className="form-row">
                            <label htmlFor="hours">Arbeitszeiten <span className="required" title="Pflichtfeld">*</span>
                                <textarea rows="8" id="hours" name="hours" validations={[required]} onChange={e => this.setState({ hours: e.target.value })}></textarea>
                            </label>
                        </div>
                        <hr/>
                        <h3>Angaben zur Rentenversicherung</h3>
                        <div className="row">
                            <div className="col">
                                <div className="form-row">
                                    <label htmlFor="status">Status bei Beginn der Beschäftigung <span className="required" title="Pflichtfeld">*</span>
                                        <select id="status" name='status' value={this.state.status} validations={[required]} onChange={e => this.setState({ status: e.target.value })}>
                                            <option value="">Bitte auswählen</option>
                                            <option value='1'>Arbeitnehmer SV Pflichtig</option>
                                            <option value='2'>Student</option>
                                            <option value='3'>Schüler</option>
                                            <option value='4'>Ausbildung</option>
                                            <option value='5'>Beamte</option>
                                            <option value='6'>Beschäftigungsloser mit Leistungsbezug</option>
                                            <option value='7'>Beschäftigungsloser ohne Leistungsbezug</option>
                                            <option value='8'>Sonstiges</option>
                                        </select>
                                    </label>
                                </div>
                                {(this.state.status == 8) ? 
                                <div className="form-row">
                                    <label htmlFor="others">Sonstiges <span className="required" title="Pflichtfeld">*</span>
                                        <input type="text" id="others" name="others" onChange={e => this.setState({ others: e.target.value })}/>
                                    </label>
                                </div>
                                : null}
                            </div>
                            <div className="col">
                                <div className="form-row">
                                    <label htmlFor="insurance">Angabe zur gesetzlichen Krankenkasse <span className="required" title="Pflichtfeld">*</span>
                                        <select id="insurance" name='insurance' value={this.state.insurance} validations={[required]} onChange={e => this.setState({ insurance: e.target.value })}>
                                            <option value="">Bitte auswählen</option>
                                            <option value='1'>Ja, bei:</option>
                                            <option value='2'>Nein: Privat versichert</option>
                                        </select>
                                    </label>
                                </div>
                                {(this.state.insurance == 1) ? 
                                <>
                                    <div className="form-row">
                                        <label htmlFor="insuranceName">Gesundheitsversicherung <span className="required" title="Pflichtfeld">*</span>
                                            <input type="text" id="insuranceName" name="insuranceName" onChange={e => this.setState({ insuranceName: e.target.value })}/>
                                        </label>
                                    </div>
                                </>
                                : null}
                                <p><strong>Art der Versicherung:</strong></p>
                                <div className="form-row">
                                    <label htmlFor="ownOwnership">
                                        <input type="checkbox" id="ownOwnership" name="insuranceOwnership" value={this.state.ownOwnership} onChange={e => this.setState({ ownOwnership: !this.state.ownOwnership })} checked={(this.state.ownOwnership) ? 'checked' : null}/>
                                        Eigene Mitgliedschaft
                                    </label>
                                </div>
                                <div className="form-row">
                                    <label htmlFor="familyOwnership">
                                        <input type="checkbox" id="familyOwnership" name="insuranceOwnership" value={this.state.familyOwnership} onChange={e => this.setState({ familyOwnership: !this.state.familyOwnership })} checked={(this.state.familyOwnership) ? 'checked' : null}/>
                                        Familienversicherung
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div className="form-row">
                                    <label htmlFor="taxID">Steuer Identifikationsnummer <span className="required" title="Pflichtfeld">*</span>
                                        <input type="text" id="taxID" name="taxID" onChange={e => this.setState({ taxID: e.target.value })}/>
                                    </label>
                                </div>
                            </div>
                            <div className="col">
                                <div className="form-row">
                                    <label htmlFor="rvID">Rentenversicherungsnummer <span className="required" title="Pflichtfeld">*</span>
                                        <input type="text" id="rvID" name="rvID" onChange={e => this.setState({ rvID: e.target.value })}/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="form-row">
                            <label htmlFor="liberation">Befreiung von der Rentenversicherungspflicht <span className="required" title="Pflichtfeld">*</span><br/><span><small><a href="/hinweis-befreiung-rentenversicherungspflicht.pdf" target="_blank" rel="noopener noreferrer" title="Merkblatt">Merkblatt</a> zur Befreiung der RV-Pflicht</small></span>
                                <select id="liberation" name='liberation' value={this.state.liberation} validations={[required]} onChange={e => this.setState({ liberation: e.target.value })}>
                                    <option value="">Bitte auswählen</option>
                                    <option value='1'>Ja ich möchte mich befreien lassen und den vollen Lohn erhalten.</option>
                                    <option value='2'>Nein ich möchte von meinem Lohn 3,6% in die Rentenversicherung einzahlen.</option>
                                </select>
                            </label>
                        </div>
                        <div className="form-row">
                            <label htmlFor="employer">Besteht derzeit eine mehrere Beschäftigungen bei einem anderen Arbeitgeber <span className="required" title="Pflichtfeld">*</span>
                                <select id="employer" name='employer' value={this.state.employer} validations={[required]} onChange={e => this.setState({ employer: e.target.value })}>
                                    <option value="">Bitte auswählen</option>
                                    <option value='1'>Ja</option>
                                    <option value='2'>Nein</option>
                                </select>
                            </label>
                        </div>
                        {(this.state.employer == '1') ?
                        <>
                            <div className="row">
                                <div className="col">
                                    <h3>Beschäftigungsbeginn</h3>
                                    <label htmlFor="beginn_1">
                                        <input type="text" id="beginn_1" name="beginn_1" placeholder="Beschäftigungsbeginn" onChange={e => this.setState({ beginn_1: e.target.value })}/>
                                    </label>
                                </div>
                                <div className="col">
                                    <h3>Arbeitgeber mit Adresse <span className="required" title="Pflichtfeld">*</span></h3>
                                    <label htmlFor="adresse_1">
                                        <textarea rows="8" id="adresse_1" name="adresse_1" placeholder="Arbeitgeber mit Adresse" onChange={e => this.setState({ adresse_1: e.target.value })}></textarea>
                                    </label>
                                </div>
                                <div className="col">
                                    <h3>Die weitere Beschäftigung ist/war</h3>
                                    <label htmlFor="option_1_1">
                                        <input type="checkbox" id="option_1_1" name="option_1_1" onChange={e => this.setState({ option_1_1: !this.state.option_1_1 })}/>
                                        geringfügig entlohnt
                                    </label>
                                    <label htmlFor="option_1_2">
                                        <input type="checkbox" id="option_1_2" name="option_1_2" onChange={e => this.setState({ option_1_2: !this.state.option_1_2 })}/>
                                        mit Eigenanteil zur RV
                                    </label>
                                    <label htmlFor="option_1_3">
                                        <input type="checkbox" id="option_1_3" name="option_1_3" onChange={e => this.setState({ option_1_3: !this.state.option_1_3 })}/>
                                        ohne Eigenanteil zur RV
                                    </label>
                                    <label htmlFor="option_1_4">
                                        <input type="checkbox" id="option_1_4" name="option_1_4" onChange={e => this.setState({ option_1_4: !this.state.option_1_4 })}/>
                                        mehr als geringfügig entlohnt
                                    </label>
                                </div>
                            </div>
                            <hr/>
                            <div className="row">
                                <div className="col">
                                    <h3>Beschäftigungsbeginn</h3>
                                    <label htmlFor="beginn_2">
                                        <input type="text" id="beginn_2" name="beginn_2" placeholder="Beschäftigungsbeginn" onChange={e => this.setState({ beginn_2: e.target.value })}/>
                                    </label>
                                </div>
                                <div className="col">
                                    <h3>Arbeitgeber mit Adresse <span className="required" title="Pflichtfeld">*</span></h3>
                                    <label htmlFor="adresse_2">
                                        <textarea rows="8" id="adresse_2" name="adresse_2" placeholder="Arbeitgeber mit Adresse" onChange={e => this.setState({ adresse_2: e.target.value })}></textarea>
                                    </label>
                                </div>
                                <div className="col">
                                    <h3>Die weitere Beschäftigung ist/war</h3>
                                    <label htmlFor="option_2_1">
                                        <input type="checkbox" id="option_2_1" name="option_2_1" onChange={e => this.setState({ option_2_1: !this.state.option_2_1 })}/>
                                        geringfügig entlohnt
                                    </label>
                                    <label htmlFor="option_2_2">
                                        <input type="checkbox" id="option_2_2" name="option_2_2" onChange={e => this.setState({ option_2_2: !this.state.option_2_2 })}/>
                                        mit Eigenanteil zur RV
                                    </label>
                                    <label htmlFor="option_2_3">
                                        <input type="checkbox" id="option_2_3" name="option_2_3" onChange={e => this.setState({ option_2_3: !this.state.option_2_3 })}/>
                                        ohne Eigenanteil zur RV
                                    </label>
                                    <label htmlFor="option_2_4">
                                        <input type="checkbox" id="option_2_4" name="option_2_4" onChange={e => this.setState({ option_2_4: !this.state.option_2_4 })}/>
                                        mehr als geringfügig entlohnt
                                    </label>
                                </div>
                            </div>
                        </>
                        : null }
                        <div className="form-row">
                            <label htmlFor="short">kurzfristige Beschäftigte <span className="required" title="Pflichtfeld">*</span>
                                <select id="short" name='short' value={this.state.short} validations={[required]} onChange={e => this.setState({ short: e.target.value })}>
                                    <option value="">Bitte auswählen</option>
                                    <option value='1'>Ja</option>
                                    <option value='2'>Nein</option>
                                </select>
                            </label>
                        </div>
                        {(this.state.short == 1) ?
                        <div className="form-row">
                            <label htmlFor="shortDays">Anzahl der Tage <span className="required" title="Pflichtfeld">*</span>
                                <input type="text" id="shortDays" name="shortDays" onChange={e => this.setState({ shortDays: e.target.value })}/>
                            </label>
                        </div>
                        : null }
                        <hr/>
                        <h3>Bankdaten</h3>
                        <div className="row">
                            <div className="col">
                                <label htmlFor="bankName">Bank <span className="required" title="Pflichtfeld">*</span>
                                    <input type="text" id="bankName" name="bankName" onChange={e => this.setState({ bankName: e.target.value })}/>
                                </label>
                            </div>
                            <div className="col">
                                <label htmlFor="bankOwner">Kontoinhaber <span className="required" title="Pflichtfeld">*</span>
                                    <input type="text" id="bankOwner" name="bankOwner" onChange={e => this.setState({ bankOwner: e.target.value })}/>
                                </label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <label htmlFor="bankIban">IBAN <span className="required" title="Pflichtfeld">*</span>
                                    <div className={cn(bank.bankIban)}>
                                        <input type="number" id="bankIban" name="bankIban" max="99999999999999999999" validations={[required, iban]} onChange={e => this.setState({ bankIban: e.target.value })}/>
                                    </div>
                                </label>
                            </div>
                            <div className="col">
                                <label htmlFor="bankBic">BIC <span className="required" title="Pflichtfeld">*</span>
                                    <input type="text" className={cn(bank.bankBic)} id="bankBic" name="bankBic" onChange={e => this.setState({ bankBic: e.target.value })}/>
                                </label>
                            </div>
                        </div>
                        <hr/>
                        <div className="form-row">
                        <label htmlFor="signature">Unterschrift <span className="required" title="Pflichtfeld">*</span>
                            <div className="signatureWrapper">
                                <SignatureCanvas ref={(ref) => { this.sigCanvas = ref }} canvasProps={{className: 'SigPad', height: 190, width: 320}}/>
                            </div>
                            <a style={{ 'cursor': 'pointer' }} onClick={(e) => this.sigCanvas.clear()}>Unterschriftenfeld zurücksetzen</a>
                        </label>
                        </div>
                        <div className="form-row">
                        <label htmlFor="user_captcha_input">Captcha <span className="required" title="Pflichtfeld">*</span>
                            <LoadCanvasTemplate/>
                            <input placeholder="Captcha Code eingeben" id="user_captcha_input" name="user_captcha_input" type="text" autoComplete="off"/>
                        </label>
                        </div>
                        <div className="form-row">
                            <label className="legal-wrapper" for="legal">
                                <input type="checkbox" name="legal" id="legal" validations={[required]}/>
                                Ich habe die <Link to="/avv-entgeltabrechnung.pdf" title="Datenschutzerklärung" target="_blank" ref="noopener noreferrer">Datenschutzerklärung</Link> gelesen und bestätige sie hiermit. <span className="required" title="Pflichtfeld">*</span>
                            </label>
                        </div>
                        <div className="form-row">
                            <label className="legal-wrapper" for="legalage">
                                <input type="checkbox" name="legalage" id="legalage" validations={[required]}/>
                                Hiermit bestätige ich, dass ich Volljährig bin. <span className="required" title="Pflichtfeld">*</span>
                            </label>
                        </div>
                        <div className="form-row">
                            <label className="legal-wrapper" for="rv">
                                <input type="checkbox" name="rv" id="rv" validations={[required]}/>
                                Hiermit bestätige ich, dass <a href="/hinweis-befreiung-rentenversicherungspflicht.pdf" target="_blank" rel="noopener noreferrer" title="Merkblatt">Merkblatt</a> zur Aufklärung über die möglichen Folgen einer Befreiung von der Rentenversicherung zur Kenntnis genommen zu haben. <span className="required" title="Pflichtfeld">*</span>
                            </label>
                        </div>
                        <p>Ich versichere, dass die vorstehenden Angaben der Wahrheit entsprechen. Ich verpflichte mich, meinem Arbeitgeber alle Änderungen, insbesondere in Bezug auf weitere Beschäftigungen (in Bezug auf Art, Dauer und Entgelt) unverzüglich mitzuteilen.</p>
                        <div className="form-row">
                            <button className="btn block standard" title="Abschicken">Abschicken</button>
                        </div>
                        {this.state.captchaError && 
                        <div className="error">
                            <p>Die Captcha Abfrage ist falsch. Bitte erneut versuchen.</p>
                        </div>
                        }
                        {this.state.requiredError && 
                        <div className="error">
                            <p>Bitte alle Pflichtfelder ausfüllen.</p>
                        </div>
                        }
                    </form>
                </div>
            </section>
        );
    }
}
 
export default Fire;